// assets/about.js  (proposed replacement - NOT applied)
// Same behaviour as before (one item open at a time) but keeps the clicked
// title where it is on screen while the previously-open item collapses.
(function () {
const initProductAccordion = () => {
$(".product-about__accordion-title").on("click keydown", function (event) {
if (event.type === "click" || event.key === "Enter") {
const title = this;
const $title = $(this);
const top0 = title.getBoundingClientRect().top;
const keepInPlace = function () {
const d = title.getBoundingClientRect().top - top0;
if (Math.abs(d) > 0.5) window.scrollBy(0, d);
};
const anim = { duration: 200, step: keepInPlace, complete: keepInPlace };
if (!$title.hasClass("active")) {
$(".product-about__accordion-title.active").removeClass("active");
$title.addClass("active");
$(".product-about__accordion-content").stop().slideUp(anim);
$title.siblings(".product-about__accordion-content").stop().slideDown(anim);
} else {
$title.removeClass("active");
$title.siblings(".product-about__accordion-content").stop().slideUp(anim);
}
}
});
};
document.addEventListener("shopify:section:load", function () { initProductAccordion(); });
initProductAccordion();
})();
